module.exports = __webpack_public_path__ + "static/media/Analytics.da1363b4.svg";